import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface NavbarProps {
  onNavigate: (page: string) => void;
  currentPage: string;
}
const NAV_LINKS = [{
  label: 'Úvod',
  href: '#uvod'
}, {
  label: 'O objektu',
  href: '#o-objektu'
}, {
  label: 'Parametry',
  href: '#parametry'
}, {
  label: 'Galerie',
  action: 'gallery'
}, {
  label: 'Lokalita',
  href: '#lokalita'
}, {
  label: 'Kontakt',
  href: '#kontakt'
}];
export function Navbar({
  onNavigate,
  currentPage
}: NavbarProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>, link: (typeof NAV_LINKS)[0]) => {
    e.preventDefault();
    setIsMobileMenuOpen(false);
    if (link.action === 'gallery') {
      onNavigate('gallery');
    } else if (link.href) {
      if (currentPage !== 'home') {
        onNavigate('home');
        // Need a slight delay to allow the home page to render before scrolling
        setTimeout(() => {
          const element = document.querySelector(link.href!);
          if (element) element.scrollIntoView({
            behavior: 'smooth'
          });
        }, 100);
      } else {
        const element = document.querySelector(link.href);
        if (element) element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-neutral-900/95 backdrop-blur-md shadow-lg py-4' : 'bg-transparent py-6'}`} data-id="element-194">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-195">
        <div className="flex justify-between items-center" data-id="element-196">
          <a href="#uvod" onClick={e => {
          e.preventDefault();
          if (currentPage !== 'home') onNavigate('home');else window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        }} className={`text-2xl font-bold tracking-tight transition-colors text-white`} data-id="element-197">
            Areál <span className="text-[#e0a812]" data-id="element-198">Žlutice</span>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex space-x-8" data-id="element-199">
            {NAV_LINKS.map(link => <a key={link.label} href={link.href || '#'} onClick={e => handleLinkClick(e, link)} className="text-sm font-medium text-neutral-300 hover:text-[#e0a812] transition-colors cursor-pointer" data-id="element-200">
                {link.label}
              </a>)}
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden text-slate-300 hover:text-white focus:outline-none" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-201">
            {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-202" /> : <MenuIcon className="w-6 h-6" data-id="element-203" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-204">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-neutral-900 border-t border-neutral-800 overflow-hidden" data-id="element-205">
            <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-206">
              {NAV_LINKS.map(link => <a key={link.label} href={link.href || '#'} onClick={e => handleLinkClick(e, link)} className="block px-3 py-3 text-base font-medium text-neutral-300 hover:text-[#e0a812] hover:bg-neutral-800 rounded-md transition-colors cursor-pointer" data-id="element-207">
                  {link.label}
                </a>)}
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}